import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { ToastComponent } from './components/toast/toast.component';
import { PhoneComponent } from './components/phone/phone.component';
import { PwinstructionsComponent } from './components/pwinstructions/pwinstructions.component';
import { PasswordComponent } from './components/password/password.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { DashLayoutComponent } from './pages/dash-layout/dash-layout.component';
import { AboutDialogComponent } from './components/about-dialog/about-dialog.component';
import { BuildinfoComponent } from './components/buildinfo/buildinfo.component';
import { FooterlinksComponent } from './components/footerlinks/footerlinks.component';
import { PopupHeaderComponent } from './components/popup-header/popup-header.component';
import { SupportDialogComponent } from './components/support-dialog/support-dialog.component';
import { UnlockAccountComponent } from '../component/unlock-account/unlock-account.component';
import { ChangePasswordComponent } from '../component/change-password/change-password.component';
import { RegistrationComponent } from '../component/registration/registration.component';
import { RegistrationSecurityquestionsComponent } from '../component/registration-securityquestions/registration-securityquestions.component';
import { DotLoaderComponent } from '../component/loader/dot-loader.component';
import { BlankComponent } from '../component/blank/blank.component';
import { SpinnerComponent } from '../component/spinner/spinner.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ToastComponent,
    PhoneComponent,
    PwinstructionsComponent,
    PasswordComponent,
    FooterComponent,
    MainLayoutComponent,
    DashLayoutComponent,
    AboutDialogComponent,
    BuildinfoComponent,
    FooterlinksComponent,
    PopupHeaderComponent,
    SupportDialogComponent,
    UnlockAccountComponent,
    ChangePasswordComponent,
    RegistrationComponent,
    RegistrationSecurityquestionsComponent,
    BlankComponent,
    SpinnerComponent,
    DotLoaderComponent,
    //FooterComponent, , LoginLayoutComponent, MainLayoutComponent, AboutDialogComponent, SupportDialogComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    HeaderComponent,
    ToastComponent,
    PhoneComponent,
    PasswordComponent,
    FooterComponent,
    MainLayoutComponent,
    DashLayoutComponent,
    AboutDialogComponent,
    BuildinfoComponent,
    FooterlinksComponent,
    PopupHeaderComponent,
    PwinstructionsComponent,
    SupportDialogComponent,
    UnlockAccountComponent,
    ChangePasswordComponent,
    RegistrationComponent,
    RegistrationSecurityquestionsComponent,
    BlankComponent,
    SpinnerComponent,
    DotLoaderComponent,
  ],
})
export class CoreModule {}
